<div class="shipping-queue" [class.embedded]="embedded">
  @if (ActionError) { <div class="action-error" role="alert">{{ ActionError }} <button [disabled]="Loading" (click)="refresh()">Retry</button></div> }
  @if (Loading) { <p role="status">Loading outbound orders…</p> }
  @if(CutoffWarning) { <p class="delivery-notice" role="status">{{CutoffWarning}}</p> }

<div class="shipping-toolbar"><nav class="shipping-filters" aria-label="Filter shipping orders"><button class="filter-chip" [class.active]="ActiveFilter === 'all'" [attr.aria-pressed]="ActiveFilter === 'all'" (click)="setFilter('all')">All <strong>{{ OutboundList.length | number }}</strong></button>
<button class="filter-chip" [class.active]="ActiveFilter === 'open'" [attr.aria-pressed]="ActiveFilter === 'open'" (click)="setFilter('open')">Open <strong>{{ openOrdersCount | number }}</strong></button>
<button class="filter-chip" [class.active]="ActiveFilter === 'attention'" [attr.aria-pressed]="ActiveFilter === 'attention'" (click)="setFilter('attention')">Needs attention <strong>{{ needAttentionCount | number }}</strong></button>
<button class="filter-chip" [class.active]="ActiveFilter === 'ready'" [attr.aria-pressed]="ActiveFilter === 'ready'" (click)="setFilter('ready')">Ready to send <strong>{{ readyToSendCount | number }}</strong></button>
<button class="filter-chip" [class.active]="ActiveFilter === 'warehouse'" [attr.aria-pressed]="ActiveFilter === 'warehouse'" (click)="setFilter('warehouse')">At warehouse <strong>{{ sentTodayCount | number }}</strong></button></nav><div class="action-buttons-row"><button class="queue-button" [class.pressed]="ShowBatches" [attr.aria-expanded]="ShowBatches" (click)="ShowBatches ? ShowBatches = false : loadBatches()"><mat-icon>inventory_2</mat-icon>Batches</button><button class="queue-button" (click)="openReconciliation()"><mat-icon>fact_check</mat-icon>Reconciliation</button><button class="queue-button primary" [disabled]="!canCreateBatch" (click)="createBatch()"><mat-icon>add</mat-icon>{{ CreatingBatch ? 'Creating…' : 'Create batch' }} @if (selectedOrders.length) { <span>({{ selectedOrders.length }})</span> }</button></div></div>
  @if (BatchSuccess) { <p class="batch-success" role="status">{{ BatchSuccess }}</p> }
  @if (selectedOrders.length) { <div class="batch-selection" role="status">
    <span>{{ batchSelectionIssue || (selectedOrders.length + ' order(s) ready to batch · ' + selectedOrders[0].Warehouse) }}</span>
    @if (selectedOrders.length) { <button mat-button (click)="clearSelection()" [disabled]="CreatingBatch">Clear selection</button> }
  </div>
  }
  @if (ShowBatches) {
    <section class="batch-panel" aria-label="Warehouse batches">
      <div class="batch-panel-heading"><strong>Recent warehouse batches</strong><button mat-button (click)="loadBatches()" [disabled]="LoadingBatches">Refresh batches</button></div>
      @if (LoadingBatches) { <p role="status">Loading batches…</p> }
      @if (BatchError) { <p role="alert">{{ BatchError }}</p> }
      @if (PreviewingBatch) { <p role="status">Preparing all documents in the batch…</p> }
      @for (batch of Batches; track batch.BatchID) {
        <details>
          <summary><strong>#{{ batch.BatchID }}</strong> · {{ batch.Warehouse }} · {{ batch.PickupDate ? (batch.PickupDate | date:'MMM d, yyyy':'UTC') : 'Pickup date not recorded' }} · {{ batch.Orders.length }} orders · {{ batch.Status }}</summary>
          <div class="batch-orders">
            <div class="batch-preview-actions">
              <button mat-stroked-button (click)="previewBatch(batch, 'Delivery Order')" [disabled]="PreviewingBatch">Preview delivery orders</button>
              <button mat-stroked-button (click)="previewBatch(batch, 'Bill of Lading')" [disabled]="PreviewingBatch">Preview bills of lading</button>
            </div>
            @for (order of batch.Orders; track order.OrderID) {
              <button mat-button (click)="openOutboundDetail(order)">#{{ order.OrderID }} · {{ order.Customer }} · {{ order.PickupDate | date:'MMM d':'UTC' }} · {{ order.StatusName }}</button>
            }
          </div>
        </details>
      } @empty { @if (!LoadingBatches && !BatchError) { <p>No warehouse batches yet.</p> } }
    </section>
  }

  <!-- NEW (5.2.25): custom grouping controls — "Group by pickup date then
       group by warehouse" is achievable directly by picking those two -->
  <div class="grouping-bar">
    <label class="history-toggle"><input type="checkbox" [(ngModel)]="IncludeCompleted" [disabled]="Loading" (change)="refresh()"> Include older &amp; completed orders</label>
<span class="queue-scope">{{ visibleOrders.length | number }} orders · {{ IncludeCompleted ? "All history" : "Last 90 days + upcoming" }}</span><button class="queue-button refresh-button" [disabled]="Loading" (click)="refresh()" aria-label="Refresh shipping orders"><mat-icon>refresh</mat-icon>Refresh</button>
    @if (selectedOrders.length > 0) { <span>{{ selectedOrders.length }} selected</span> }
    <label>Group by:</label>
    <select aria-label="Group shipping orders by" [(ngModel)]="PrimaryGroupField">
      @for (opt of GroupFieldOptions; track opt.value) {
      <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
    @if (isGrouped) {
    <label>then:</label>
    <select aria-label="Then group shipping orders by" [(ngModel)]="SecondaryGroupField">
      @for (opt of GroupFieldOptions; track opt.value) {
      <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
    }
  </div>

  <div class="shipping-table-panel">
  @if (!isGrouped) {
  <rms-table [HeaderButtons]="embedded ? [] : Buttons"
             [parentContext]="this"
             [data]="visibleOrders"
             [columns]="OutboundColumns"
             [layoutType]="'Outbound'"
             tableId="outbound-management-main"
             [customizable]="true"
             startSort="PickupDate"
             startSortDirection="asc">
  </rms-table>
  } @else {
  <!-- Grouped view: plain nested sections rather than rms-table, since
       the shared table component doesn't support grouped rendering -->
  <div class="grouped-list">
    @for (bucket of groupedOrders; track bucket.label) {
    <div class="group-bucket">
      <h4 class="group-header">{{ bucket.label }}</h4>
      @for (sub of bucket.subgroups; track sub.label) {
      @if (sub.label) {
      <h5 class="subgroup-header">{{ sub.label }}</h5>
      }
      <table class="doc-table">
        <thead>
          <tr><th>Select</th><th>Order #</th><th>Customer</th><th>Bags</th><th>Warehouse</th><th>Pickup</th><th>Status</th><th>Next action</th></tr>
        </thead>
        <tbody>
          @for (order of sub.orders; track order.OrderID) {
          <tr>
            <td><input type="checkbox" [(ngModel)]="order.Selected" [attr.aria-label]="'Select order ' + order.OrderID" /></td>
            <td><button class="order-link" (click)="openOutboundDetail(order)">{{ order.OrderID }}</button></td>
            <td>{{ order.Customer }}</td>
            <td>{{ order.Bags }}</td>
            <td>{{ order.Warehouse }}</td>
            <td>{{ order.PickupDate | date:'MM-dd-yyyy':'UTC' }}</td>
            <td>{{ order.StatusName }}</td>
            <td>{{ order.NextAction }}</td>
          </tr>
          }
        </tbody>
      </table>
      }
    </div>
    }
  </div>
  }

  </div>
</div>
